import { useState, useLayoutEffect } from 'react';
import * as MockHook from '../../../src/util/useMockHook';

export const DEFAULT_LINE_HEIGHT = 24;

const getStyleSize = (style?: string) =>
  style ? Number(style.split('px')[0]) : 0;

export interface ExpandableTextProps {
  id: string;
  text: string;
  maxLines: number;
  expandText?: string;
  collapseText?: string;
  className?: string;
}
const useExpandableTextLogic = (props: ExpandableTextProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  // Use text element height and line-height to determine
  // If expandText should be shown
  const [config, setConfig] = useState({
    hasOverflow: false,
    lineHeight: DEFAULT_LINE_HEIGHT,
  });
  const { id, maxLines, text } = props;
  useLayoutEffect(() => {
    const element = document.getElementById(id);
    const elementStyle = element && window.getComputedStyle(element);
    const elementHeight = getStyleSize(elementStyle?.height);
    const elementLineHeight =
      getStyleSize(elementStyle?.lineHeight) || DEFAULT_LINE_HEIGHT;

    setConfig({
      hasOverflow: elementHeight > maxLines * elementLineHeight,
      lineHeight: elementLineHeight,
    });
  }, [text]);

  const toggleExpand = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setIsExpanded((currIsExpanded) => !currIsExpanded);
  };
  return { isExpanded, toggleExpand, ...config, ...props };
};

export type ExpandableTextComponentProps = ReturnType<
  typeof useExpandableTextLogic
>;

export const MOCK_EXPANDABLE_TEXT_PROPS: ExpandableTextComponentProps = {
  id: '1',
  text:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  maxLines: 3,
  isExpanded: false,
  hasOverflow: true,
  lineHeight: DEFAULT_LINE_HEIGHT,
  toggleExpand: MockHook.mockFunction,
};
export default MockHook.useMockHook(
  useExpandableTextLogic,
  MOCK_EXPANDABLE_TEXT_PROPS
);
